import { DemandPlanContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const DemandPlanPage = () => {
  return (
    <PageFrame>
      <DemandPlanContainer />
    </PageFrame>
  );
};
